// const config = {
//   BASE_API_URL: 'http://localhost:5001',
//   API_URL: 'http://localhost:5001/api',
// };
const config = {
    BASE_API_URL: 'https://api.canvaart.in',
    API_URL: 'https://api.canvaart.in/api',
};

export default config;